export const IMAGE_BASE_PATH =
    process.env.REACT_APP_IMAGE_BASE_PATH || '/content';

export const FONT_BASE_PATH = process.env.REACT_APP_FONT_BASE_PATH || '/fonts';

export const LANDING_PAGE_BASE_URL =
    process.env.REACT_APP_LANDING_PAGE_BASE_URL || 'https://itv7.itv.com';

export const API_SWEEPS_BASE_URL =
    process.env.REACT_APP_API_SWEEPS_BASE_URL ||
    'https://api.sweeps.sbgservice.com';

export const API_ITV7_BASE_URL =
    process.env.REACT_APP_API_ITV7_BASE_URL || 'https://itv7.itv.com/api/v2';

export const API_TIMEOUT = process.env.REACT_APP_API_TIMEOUT || 6000;

export const SWEEP_CONSUMER_ID =
    process.env.REACT_APP_SWEEP_CONSUMER_ID || 'ITV7';

export const BASE_PATH = process.env.REACT_APP_BASE_PATH || '/';

export const PUBLIC_URL = process.env.PUBLIC_URL || '';

export const FEATURE_URL = process.env.REACT_APP_FEATURE_URL || '';

export const SSO_URI =
    process.env.REACT_APP_SSO_URI || 'https://identitysso.skybetservices.com';

export const SSO_ACCOUNT_URI =
    process.env.REACT_APP_SSO_ACCOUNT_URI ||
    'https://myaccount.skybetservices.com';

export const ITV7_FOOTBALL_TERMS_URL =
    process.env.REACT_APP_ITV7_FOOTBALL_TERMS_URL ||
    'https://web.flutter.checkd-dev.com/terms.html';

export const CROSS_SELL_SKY_BET_URL =
    process.env.REACT_APP_CROSS_SELL_SKY_BET_URL || 'https://skybet.com';

export const generateGoogleAnalyticsURL = (i, dl) =>
    `https://www.googletagmanager.com/gtm.js?id=${i}${dl}${process.env
        .REACT_APP_GA_URL ?? ''}`;
